import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client';
import { gql } from '../../../common/gql';
import { IntercomArticleQuery, IntercomArticleQueryVariables } from '../../../common/gql/graphql';

export const intercomArticleQuery = gql(/* GraphQL */ `
  query IntercomArticleQuery($url: String!) {
    intercomArticle(url: $url)
  }
`);

export const useLazyIntercomArticleQuery = (
  options: LazyQueryHookOptions<IntercomArticleQuery, IntercomArticleQueryVariables>,
) => useLazyQuery(intercomArticleQuery, options);
